module.exports = __webpack_public_path__ + "img/11.f7a798ab.jpg";